export enum ErrorCodes {
  BAD_METHOD_CALL = 400,
  UNAUTHORIZED = 401,
  NOT_FOUND = 404,
  PRECONDITION_FAILED = 412,
}
